import React from 'react';
import './Avatar.css';

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
  fallback?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src = '😊',
  alt = 'Avatar',
  size = 'medium',
  className = '',
  fallback = '😊'
}) => {
  const isEmoji = src && src.length <= 2 && /\p{Emoji}/u.test(src);
  const isDataUrl = src && src.startsWith('data:');
  const isUrl = src && (src.startsWith('http') || src.startsWith('https'));

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // If image fails to load, show fallback emoji
    const target = e.target as HTMLImageElement;
    target.style.display = 'none';
    const parent = target.parentElement;
    if (parent) {
      parent.innerHTML = `<div class="avatar-emoji">${fallback}</div>`;
    }
  };

  return (
    <div className={`avatar avatar-${size} ${className}`}>
      {isEmoji ? (
        <div className="avatar-emoji">{src}</div>
      ) : (isDataUrl || isUrl) ? (
        <img 
          src={src} 
          alt={alt} 
          className="avatar-image"
          onError={handleImageError}
        />
      ) : (
        <div className="avatar-emoji">{fallback}</div>
      )}
    </div>
  );
};

export default Avatar;
